import React from 'react';
import Header from './Header';
import BottomNav from './BottomNav';

export default function AppShell({ children }) {
  return (
    <div className="app-shell">
      <Header />
      {children}
      <BottomNav />
    </div>
  );
}
